import React from "react";
import Header from "./Header";
import MainComponent from "./MainComponent";
import Footer from "./Footer";
import FooterDown from "./FooterDown";
import HeroSection from "./HeroSection";

const LandingPage = () => {
  return (
    <div>
      <Header />
      <MainComponent />
      <HeroSection />
      <Footer />
      <FooterDown />
    </div>
  );
};

export default LandingPage;
